import * as fromDatatype from '../datatype-library/index';

//some of the data type are wrong, don't have boolean and byte data field interface
export interface app_file_item_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  file_name: fromDatatype.VarcharDatatypeInterface;
  file_type: fromDatatype.VarcharDatatypeInterface;
  file_extension: fromDatatype.VarcharDatatypeInterface;
  file_description: fromDatatype.TextDatatypeInterface;
  directory_path: fromDatatype.VarcharDatatypeInterface;
  directory_depth: fromDatatype.IntegerDatatypeInterface;
  mime_type: fromDatatype.VarcharDatatypeInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  subject_perm_read: string;//  should be boolean
  subject_perm_write: string;//  should be boolean
  subject_perm_execute: string;//  should be boolean
  group_perm_read: string;//  should be boolean
  group_perm_write: string;//  should be boolean
  group_perm_execute: string;//  should be boolean
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_edited: fromDatatype.TimestampTzDatatypeInterface;
  date_accessed: fromDatatype.TimestampTzDatatypeInterface;
  content_type: fromDatatype.VarcharDatatypeInterface;
  content_binary: string;  //should be byte
  content_json: fromDatatype.GuidDataFieldInterface;
  content_txt: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  storage_service: fromDatatype.VarcharDatatypeInterface;
  file_url: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;

}

export class app_file_item_RowClass implements app_file_item_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  file_name: fromDatatype.VarcharDatatypeInterface;
  file_type: fromDatatype.VarcharDatatypeInterface;
  file_extension: fromDatatype.VarcharDatatypeInterface;
  file_description: fromDatatype.TextDatatypeInterface;
  directory_path: fromDatatype.VarcharDatatypeInterface;
  directory_depth: fromDatatype.IntegerDatatypeInterface;
  mime_type: fromDatatype.VarcharDatatypeInterface;
  subject_guid: fromDatatype.GuidDataFieldInterface;
  subject_perm_read: string;//  should be boolean
  subject_perm_write: string;//  should be boolean
  subject_perm_execute: string;//  should be boolean
  group_perm_read: string;//  should be boolean
  group_perm_write: string;//  should be boolean
  group_perm_execute: string;//  should be boolean
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_edited: fromDatatype.TimestampTzDatatypeInterface;
  date_accessed: fromDatatype.TimestampTzDatatypeInterface;
  content_type: fromDatatype.VarcharDatatypeInterface;
  content_binary: string;
  content_json: fromDatatype.GuidDataFieldInterface;
  content_txt: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  storage_service: fromDatatype.VarcharDatatypeInterface;
  file_url: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;


}


